import { colors, fontSizes } from '../../../consts'
import { styled } from '@mui/system'

export const ErrorText = styled('div')(({ theme }) => ({
  fontSize: fontSizes.small,
  color: colors.red,
  margin: 5,
}))
